var map = {
	"./barcode-img.png": 120,
	"./carousel-btn.png": 173,
	"./carousel-pic1.png": 124,
	"./carousel-pic2.png": 55,
	"./carousel-pic3.png": 558,
	"./carousel-pic4.png": 41,
	"./carousel-pic5.png": 912,
	"./carousel-pic6.png": 523,
	"./icon-open.png": 174,
	"./main-banner-02.png": 313,
	"./market-btn-box.png": 947,
	"./market-btn-oneclick.png": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;